export const projects = {
  hero: {
    title: 'Our Projects & Programs',
    subtitle: 'Discover how we\'re making a tangible difference through targeted programs in emergency aid, healthcare, education, food security, and shelter for refugees and vulnerable communities across the Uganda.',
  },
  categories: {
    all: 'All Projects',
    food: 'Food',
    healthcare: 'Healthcare',
    shelter: 'Shelter',
    education: 'Education',
  },
  urgency: {
    critical: '🔴 Critical Need',
    high: '🟠 High Priority',
    medium: '🟡 Ongoing Need',
    low: '✅ Goal Reached',
  },
  status: {
    active: 'Active',
    completed: 'Completed',
  },
  card: {
    raised: 'Raised',
    goal: 'Goal',
    funded: 'funded',
    supportButton: 'Support This Project',
    completedButton: 'Project Completed',
  },
  cta: {
    title: 'Every Contribution Counts',
    subtitle: 'Whether it\'s $10 or $10,000 — your support directly reaches families in need across the Uganda. Choose any project above or make a general donation.',
    donateButton: 'Donate Now',
  },
   contact: {
     // Page Header
     title: 'Contact Us',
     subtitle: 'We\'re here to help and answer any questions you might have. Whether you\'re a donor, partner, volunteer, or simply someone who wants to learn more about our work—we\'d love to hear from you.',
     responseTime: 'We usually respond within 24 hours.',
     headerCta: {
       becomePartner: 'Become a Partner',
       supportMission: 'Support Our Mission',
     },

     // Contact Info Cards
     email: {
       title: 'Email Address',
       address: 'info@handsofhope.org',
     },
     phone: {
       title: 'Phone Number',
       number: '+256773515447',
     },
     location: {
       title: 'Office Address',
       address: 'Goma, North Kivu\nDemocratic Republic of Congo',
     },
     workingHours: {
       title: 'Working Hours',
       weekdays: 'Monday - Friday',
       time: '8:00 AM - 6:00 PM',
       weekend: 'Saturday',
       weekendTime: '9:00 AM - 2:00 PM',
       timezone: 'Central Africa Time (CAT)',
     },

     // Social Media
     social: {
       title: 'Connect With Us',
       followOn: 'Follow us on',
     },

     // Quick Support Section
     quickSupport: {
       title: 'Need Urgent Assistance?',
       description: 'If you require immediate support or have an urgent inquiry, please reach out directly:',
       callNow: 'Call Now',
       emailNow: 'Email Us',
       tollFree: 'Toll-Free Hotline',
       hotlineNumber: '+256 800 123 456',
     },

     // Contact Form
     form: {
       title: 'Send Us a Message',
       name: 'Full Name',
       email: 'Email Address',
       phone: {
         label: 'Phone Number (Optional)',
         placeholder: '+1234567890',
       },
       subject: 'Subject',
       subjectPlaceholder: 'Select a topic',
       subjectOptions: {
         general: 'General Inquiry',
         donation: 'Donation & Giving',
         volunteer: 'Volunteer Opportunities',
         partnership: 'Partnership & Collaboration',
         media: 'Media & Press',
         other: 'Other',
       },
       message: 'Your Message',
       messagePlaceholder: 'Tell us how we can help you...',
       phoneNumberLabel: 'Phone Number',
       charactersLimit: 'characters',
       submitButton: 'Send Message',
       submitting: 'Sending...',
       successMessage: 'Thank you for reaching out! We have received your message and will get back to you within 24 hours.',
       errorMessage: 'Something went wrong. Please try again.',
     },

     // FAQ Section
     faq: {
       title: 'Frequently Asked Questions',
       items: [
         {
           question: 'How quickly will I receive a response?',
           answer: 'We strive to respond to all inquiries within 24 hours during business days. For urgent matters, please use our Quick Support hotline.',
         },
         {
           question: 'How can I volunteer with Hands of Hope?',
           answer: 'Visit our Get Involved page to explore volunteer opportunities, or select "Volunteer Opportunities" in the contact form above and we\'ll guide you through the process.',
         },
         {
           question: 'What types of donations do you accept?',
           answer: 'We accept one-time and recurring monetary donations, in-kind contributions, and corporate partnerships. Contact our donor relations team for more information.',
         },
         {
           question: 'How can I partner with your organization?',
           answer: 'We welcome partnerships with corporations, NGOs, and community organizations. Select "Partnership" in the form or email us at partnerships@handsofhope.org.',
         },
       ],
     },

     // Map & Footer CTAs
     map: {
       title: 'Our Location',
       getDirections: 'Get Directions',
     },
     cta: {
       partnerTitle: 'Become a Partner',
       partnerDesc: 'Join us in creating lasting change by becoming a strategic partner.',
       donateTitle: 'Support Our Mission',
       donateDesc: 'Your contribution, big or small, directly impacts lives across the Uganda.',
       donateButton: 'Donate Now',
       partnerButton: 'Learn More',
     },
   },
};
